import {useRef} from 'react'

export const useKeepMounted = (show: boolean): boolean => {
  const mounted = useRef(show)

  mounted.current ||= show

  return mounted.current
}
